module.exports = __webpack_public_path__ + "static/media/img6.0c569a47.png";